import TipTapEditor from "../../TiptapEditor/TiptapEditor";
import React, {useState} from "react";
import "./SendMailForm.css";
import authService from "../../../../services/authService";
import {useVerifyLogin} from "../../common/formFunctionSharing";
import {Button, Form} from "react-bootstrap";
import {sendSimpleMail} from "../../../../services/mailsService";


function SendMailForm({cci, userCount, hideWindowState}) {

    const user = authService.getCurrentUserToken();
    useVerifyLogin(user);

    const [object, setObject] = useState('Message du Programme de jumelage - Bureau de la vie étudiante');
    const [messageBody, setMessageBody] = useState('');
    const [bodyError, setBodyError] = useState(false);
    const [isConfirming, setIsConfirming] = useState(false);
    const [sendStatus, setSendStatus] = useState('idle'); // idle | sending | success | error
    const recipients = cci.split(',').map(mail => mail.trim()).filter(mail => mail !== '');

    // Le message est vide s'il ne reste aucun texte une fois les balises HTML retirées (ex.: "<p></p>")
    const isBodyEmpty = (html) => html.replace(/<[^>]*>|&nbsp;/g, '').trim() === '';

    const handleObjectChange = (e) => {
        setObject(e.target.value);
    }

    const handleBodyChange = (text) => {
        setMessageBody(text);
        if (bodyError && !isBodyEmpty(text)) setBodyError(false);
    }

    const handleSendMail = async (e) => {
        e.preventDefault();
        if (isBodyEmpty(messageBody)) {
            setBodyError(true);
            return;
        }
        setIsConfirming(true);
    }

    const handleConfirmSend = async () => {
        setSendStatus('sending');
        try {
            await sendSimpleMail(messageBody, object, "", cci);
            setSendStatus('success');
        } catch (e) {
            console.error(e.message);
            setSendStatus('error');
        }
    }

    return(
        <div>
            {sendStatus === 'success' && (
                <div style={{textAlign: "center", padding: "30px 10px"}}>
                    <div style={{fontSize: "3rem", color: "#198754", lineHeight: 1}}>✓</div>
                    <h5 style={{marginTop: 12}}>Message envoyé avec succès</h5>
                    <p className="text-muted">Envoyé à {userCount} usager{userCount > 1 ? "s" : ""} ({recipients.length} adresse{recipients.length > 1 ? "s" : ""}).</p>
                    <Button variant="dark" onClick={hideWindowState}>Fermer</Button>
                </div>
            )}
            {sendStatus !== 'success' && isConfirming && (
                <div style={{padding: "4px 2px"}}>
                    <div style={{display: "flex", alignItems: "center", gap: 10, marginBottom: 16}}>
                        <h5 style={{margin: 0, fontWeight: 600}}>Confirmer l'envoi</h5>
                        <span style={{background: "#e7f1ff", color: "#0b5ed7", borderRadius: 999, padding: "2px 12px", fontSize: "0.8rem", fontWeight: 600}}>
                            {userCount} usager{userCount > 1 ? "s" : ""} · {recipients.length} adresse{recipients.length > 1 ? "s" : ""}
                        </span>
                    </div>

                    <div style={{border: "1px solid #e1e4e8", borderRadius: 10, overflow: "hidden", marginBottom: 16, boxShadow: "0 1px 2px rgba(0,0,0,0.05)"}}>
                        <div style={{background: "#f6f8fa", padding: "10px 16px", borderBottom: "1px solid #e1e4e8"}}>
                            <div style={{fontSize: "0.7rem", color: "#6c757d", textTransform: "uppercase", letterSpacing: 0.6}}>Objet</div>
                            <div style={{fontWeight: 600}}>{object}</div>
                        </div>
                        <div
                            style={{maxHeight: 160, overflowY: "auto", background: "#fff", padding: "12px 16px", fontSize: "0.9rem"}}
                            dangerouslySetInnerHTML={{__html: messageBody}}
                        />
                    </div>

                    <div style={{border: "1px solid #e1e4e8", borderRadius: 10, overflow: "hidden", marginBottom: 20, boxShadow: "0 1px 2px rgba(0,0,0,0.05)"}}>
                        <div style={{background: "#f6f8fa", padding: "8px 16px", borderBottom: "1px solid #e1e4e8", fontSize: "0.7rem", color: "#6c757d", textTransform: "uppercase", letterSpacing: 0.6}}>
                            Destinataires (en copie conforme invisible)
                        </div>
                        <div style={{display: "flex", flexWrap: "wrap", gap: 6, maxHeight: 180, overflowY: "auto", padding: 12, background: "#fff"}}>
                            {recipients.map(mail => (
                                <span key={mail} style={{
                                    fontSize: "0.72rem", lineHeight: 1.4,
                                    background: "#f1f3f5", color: "#343a40",
                                    borderRadius: 6, padding: "3px 9px"
                                }}>{mail}</span>
                            ))}
                        </div>
                    </div>

                    {sendStatus === 'error' && (
                        <div className="alert alert-danger" role="alert">
                            Le message n'a pas pu être envoyé. Veuillez réessayer, ou utiliser ListServ si le problème persiste.
                        </div>
                    )}

                    <div style={{display: "flex", justifyContent: "flex-end", gap: 10}}>
                        <Button variant="outline-secondary" disabled={sendStatus === 'sending'} onClick={() => {setSendStatus('idle'); setIsConfirming(false);}}>Retour</Button>
                        <Button variant="success" disabled={sendStatus === 'sending'} onClick={handleConfirmSend}>
                            {sendStatus === 'sending' ? "Envoi en cours..." : sendStatus === 'error' ? "Réessayer" : "Confirmer l'envoi"}
                        </Button>
                    </div>
                </div>
            )}
            <Form onSubmit={handleSendMail} style={{display: isConfirming || sendStatus === 'success' ? "none" : "block"}}>
                <Form.Group className="objet" controlId="Objet">
                    <Form.Label>Objet</Form.Label>
                    <Form.Control required type="text" value={object} onChange={handleObjectChange}/>
                </Form.Group>
                <TipTapEditor value={messageBody} onChange={handleBodyChange}/>
                {bodyError && <div className="text-danger" style={{marginTop:6}}>Le message ne peut pas être vide.</div>}
                <Button variant="dark" className="submitBtn" type="submit">Envoyer</Button>
            </Form>
        </div>
    );
}

export default SendMailForm;